import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

export function NotFound() {
  const { t } = useTranslation('general');

  return (
    <main className="flex flex-col items-center justify-center gap-3 p-8 text-center">
      <h1 className="text-xl font-semibold text-neut-prim">
        {t('not_found.title')}
      </h1>
      <p className="max-w-md text-sm text-neut-sec">{t('not_found.body')}</p>
      <Link
        to="/dashboard"
        className="text-sm text-prim underline underline-offset-2"
      >
        {t('not_found.back')}
      </Link>
    </main>
  );
}
